var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tooltip",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.058,
    height: 15.058,
    viewBox: "0 0 15.058 15.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_775",
    "data-name": "Trazado 775",
    d: "M86.776-868.707h1.506v-4.517H86.776Zm.753-6.023a.729.729,0,0,0,.536-.216.729.729,0,0,0,.216-.536.728.728,0,0,0-.216-.536.728.728,0,0,0-.536-.217.728.728,0,0,0-.536.217.728.728,0,0,0-.216.536.729.729,0,0,0,.216.536A.729.729,0,0,0,87.529-874.73Zm0,9.788a7.331,7.331,0,0,1-2.936-.593,7.6,7.6,0,0,1-2.39-1.609,7.6,7.6,0,0,1-1.609-2.39A7.331,7.331,0,0,1,80-872.471a7.331,7.331,0,0,1,.593-2.936A7.6,7.6,0,0,1,82.2-877.8a7.6,7.6,0,0,1,2.39-1.609A7.331,7.331,0,0,1,87.529-880a7.331,7.331,0,0,1,2.936.593,7.6,7.6,0,0,1,2.39,1.609,7.6,7.6,0,0,1,1.609,2.391,7.331,7.331,0,0,1,.593,2.936,7.331,7.331,0,0,1-.593,2.936,7.6,7.6,0,0,1-1.609,2.39,7.6,7.6,0,0,1-2.39,1.609A7.331,7.331,0,0,1,87.529-864.942Zm0-1.506A5.813,5.813,0,0,0,91.8-868.2a5.814,5.814,0,0,0,1.75-4.273,5.813,5.813,0,0,0-1.75-4.273,5.813,5.813,0,0,0-4.273-1.75,5.813,5.813,0,0,0-4.273,1.75,5.813,5.813,0,0,0-1.75,4.273,5.813,5.813,0,0,0,1.75,4.273A5.813,5.813,0,0,0,87.529-866.448ZM87.529-872.471Z",
    transform: "translate(-80 880)",
    fill: "#dcdadd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.c0b8c4b40fb3225b0f1dd7c1b35e9eac.svg";
export { ForwardRef as ReactComponent };